import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import IFTrackerPrivacy from "./pages/IFTrackerPrivacy";
import AccountDeletion from "./pages/AccountDeletion";
import PDFToolkitPrivacy from "./pages/PDFToolkitPrivacy";
import PDFToolkitAIAccountDeletion from "./pages/AccountDeletionPDFToolkitAI";
import CosmovexLanding from "./pages/CosmovexLanding";
import AppPromoPage from "./pages/AppPromoPage";
import XMLVEditLanding from "./pages/XMLVEditLanding";
import PyVEditLanding from "./pages/PyVEditLanding";
import SQLVEditLanding from "./pages/SQLVEditLanding";
import HostPilotLanding from "./pages/HostPilotLanding";
import AspenoteLanding from "./pages/AspenoteLanding";
import AppsIndex from "./pages/AppsIndex";
import AppDownloadPage from "./pages/AppDownloadPage";
import Blogs from "./pages/Blogs";
import BlogPost from "./pages/BlogPost";
import { BlogAdmin } from "./pages/BlogAdmin";
import ContentStudio from "./pages/ContentStudio";
import SmartDownload from "./pages/SmartDownload";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import EasyKhataPrivacyPolicy from "./pages/EasyKhataPrivacy";
import EasyKhataAccountDeletion from "./pages/EasyKhataAccountDeletion";
import WebEvaPrivacy from "./pages/WebEvaPrivacy";
import WebEvaAccountDeletion from "./pages/WebEvaAccountDeletion";
import HTMLVEditPrivacy from "./pages/HTMLVEditPrivacy";
import HTMLVEditSupport from "./pages/HTMLVEditSupport";
import JSONVEditPrivacy from "./pages/JSONVEditPrivacy";
import JSONVEditSupport from "./pages/JSONVEditSupport";
import DiagramMakerPrivacy from "./pages/DiagramMakerPrivacy";
import DiagramMakerSupport from "./pages/DiagramMakerSupport";
import PromptCratePrivacy from "./pages/PromptCratePrivacy";
import PromptCrateSupport from "./pages/PromptCrateSupport";
import QRPilotPrivacy from "./pages/QRPilotPrivacy";
import QRPilotSupport from "./pages/QRPilotSupport";
import ReelPilotPrivacy from "./pages/ReelPilotPrivacy";
import ReelPilotSupport from "./pages/ReelPilotSupport";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RESTPilotPrivacy from "./pages/RESTPilotPrivacy";
import RESTPilotSupport from "./pages/RESTPilotSupport";
import DevBuddyPrivacy from "./pages/DevBuddyPrivacy";
import DevBuddySupport from "./pages/DevBuddySupport";
import ShellPilotPrivacy from "./pages/ShellPilotPrivacy";
import ShellPilotAccountDeletion from "./pages/ShellPilotAccountDeletion";
import PDFVEditAIPrivacy from "./pages/PDFVEditAIPrivacy";
import PDFVEditAIAccountDeletion from "./pages/PDFVEditAIAccountDeletion";
import PDFVEditAISupport from "./pages/PDFVEditAISupport";
import ShellPilotSupport from "./pages/ShellPilotSupport";
import WebEvaSupport from "./pages/WebEvaSupport";
import FitterAIPrivacy from "./pages/FitterAIPrivacy";
import FitterAITerms from "./pages/FitterAITerms";
import FitterAISupport from "./pages/FitterAISupport";
import FitterAIAccountDeletion from "./pages/FitterAIAccountDeletion";
import XMLVEditPrivacy from "./pages/XMLVEditPrivacy";
import XMLVEditSupport from "./pages/XMLVEditSupport";
import SQLVEditPrivacy from "./pages/SQLVEditPrivacy";
import SQLVEditSupport from "./pages/SQLVEditSupport";
import NetToolkitPrivacy from "./pages/NetToolkitPrivacy";
import NetToolkitSupport from "./pages/NetToolkitSupport";
import MDVEditPrivacy from "./pages/MDVEditPrivacy";
import MDVEditSupport from "./pages/MDVEditSupport";
import TextVEditPrivacy from "./pages/TextVEditPrivacy";
import TextVEditSupport from "./pages/TextVEditSupport";
import CSVVEditPrivacy from "./pages/CSVVEditPrivacy";
import CSVVEditSupport from "./pages/CSVVEditSupport";
import PyVEditPrivacy from "./pages/PyVEditPrivacy";
import PyVEditSupport from "./pages/PyVEditSupport";
import JavaVEditPrivacy from "./pages/JavaVEditPrivacy";
import JavaVEditSupport from "./pages/JavaVEditSupport";
import JSVEditPrivacy from "./pages/JSVEditPrivacy";
import JSVEditSupport from "./pages/JSVEditSupport";
import SVGVEditPrivacy from "./pages/SVGVEditPrivacy";
import SVGVEditSupport from "./pages/SVGVEditSupport";
import MarkPilotPrivacy from "./pages/MarkPilotPrivacy";
import MarkPilotSupport from "./pages/MarkPilotSupport";
import HostPilotPrivacy from "./pages/HostPilotPrivacy";
import HostPilotSupport from "./pages/HostPilotSupport";
import ImgPilotPrivacy from "./pages/ImgPilotPrivacy";
import ImgPilotSupport from "./pages/ImgPilotSupport";
import HeicveditPrivacy from "./pages/HeicveditPrivacy";
import HeicveditSupport from "./pages/HeicveditSupport";
import YamlveditPrivacy from "./pages/YamlveditPrivacy";
import YamlveditSupport from "./pages/YamlveditSupport";
import ZipVEditPrivacy from "./pages/ZipVEditPrivacy";
import ZipVEditSupport from "./pages/ZipVEditSupport";
import LayerPeekPrivacy from "./pages/LayerPeekPrivacy";
import LayerPeekSupport from "./pages/LayerPeekSupport";
import PartyDarePrivacy from "./pages/PartyDarePrivacy";
import PartyDareSupport from "./pages/PartyDareSupport";
import AgentPagerPrivacy from "./pages/AgentPagerPrivacy";
import AgentPagerSupport from "./pages/AgentPagerSupport";
import AgentPagerLanding from "./pages/AgentPagerLanding";
import AgentPagerGet from "./pages/AgentPagerGet";
import CodeTycoonPrivacy from "./pages/CodeTycoonPrivacy";
import CodeTycoonSupport from "./pages/CodeTycoonSupport";
import CVEditPrivacy from "./pages/CVEditPrivacy";
import CVEditSupport from "./pages/CVEditSupport";
import PHPVEditPrivacy from "./pages/PHPVEditPrivacy";
import PHPVEditSupport from "./pages/PHPVEditSupport";
import TermsOfService from "./pages/TermsOfService";
import About from "./pages/About";
import Contact from "./pages/Contact";
import UnsubscribePage from "./pages/UnsubscribePage";
import CookieConsent from "./components/CookieConsent";
import JavaIdeAndroid from "./pages/seo/JavaIdeAndroid";
import RunJavaOnPhone from "./pages/seo/RunJavaOnPhone";
import JavascriptEditorAndroid from "./pages/seo/JavascriptEditorAndroid";
import RunJavascriptOnPhone from "./pages/seo/RunJavascriptOnPhone";
import SqliteViewerAndroid from "./pages/seo/SqliteViewerAndroid";
import SqlRunnerAndroid from "./pages/seo/SqlRunnerAndroid";
import PythonOnAndroid from "./pages/seo/PythonOnAndroid";
import OfflinePythonAndroid from "./pages/seo/OfflinePythonAndroid";
import PythonCompilerAndroid from "./pages/seo/PythonCompilerAndroid";
import LearnPythonOnPhone from "./pages/seo/LearnPythonOnPhone";
import SshClientAndroid from "./pages/seo/SshClientAndroid";
import SftpClientAndroid from "./pages/seo/SftpClientAndroid";
import PuttyForAndroid from "./pages/seo/PuttyForAndroid";
import TerminalEmulatorAndroid from "./pages/seo/TerminalEmulatorAndroid";
import ManageServerFromPhone from "./pages/seo/ManageServerFromPhone";
import TermuxAlternativeAndroid from "./pages/seo/TermuxAlternativeAndroid";
import JuiceSshAlternativeAndroid from "./pages/seo/JuiceSshAlternativeAndroid";
import WebsiteBuilderAndroid from "./pages/seo/WebsiteBuilderAndroid";
import HtmlEditorMobile from "./pages/seo/HtmlEditorMobile";
import XmlViewerAndroid from "./pages/seo/XmlViewerAndroid";
import JsonViewerAndroid from "./pages/seo/JsonViewerAndroid";
import SvgEditorAndroid from "./pages/seo/SvgEditorAndroid";
import CsvViewerAndroid from "./pages/seo/CsvViewerAndroid";
import PdfEditorAndroid from "./pages/seo/PdfEditorAndroid";
import UnitConverterAndroid from "./pages/seo/UnitConverterAndroid";
import YamlViewerAndroid from "./pages/seo/YamlViewerAndroid";
import MarkdownEditorAndroid from "./pages/seo/MarkdownEditorAndroid";
import TextEditorAndroid from "./pages/seo/TextEditorAndroid";
import NetworkToolsAndroid from "./pages/seo/NetworkToolsAndroid";
import FitnessAiAndroid from "./pages/seo/FitnessAiAndroid";
import RestApiTesterAndroid from "./pages/seo/RestApiTesterAndroid";
import HtmlViewerAndroid from "./pages/seo/HtmlViewerAndroid";
import JsonFormatterAndroid from "./pages/seo/JsonFormatterAndroid";
import SqlEditorAndroid from "./pages/seo/SqlEditorAndroid";
import YamlEditorAndroid from "./pages/seo/YamlEditorAndroid";
import DeveloperToolsAndroid from "./pages/seo/DeveloperToolsAndroid";
import JavaCompilerAndroid from "./pages/seo/JavaCompilerAndroid";
import DiagramMakerAndroid from "./pages/seo/DiagramMakerAndroid";
import QrScannerAndroid from "./pages/seo/QrScannerAndroid";
import QrCodeGeneratorAndroid from "./pages/seo/QrCodeGeneratorAndroid";
import BarcodeScannerAndroid from "./pages/seo/BarcodeScannerAndroid";
import ZipExtractorAndroid from "./pages/seo/ZipExtractorAndroid";
import AiPromptManagerAndroid from "./pages/seo/AiPromptManagerAndroid";
import AiMarkdownNotesAndroid from "./pages/seo/AiMarkdownNotesAndroid";
import SaveChatgptPrompts from "./pages/seo/SaveChatgptPrompts";
import AiPromptTemplates from "./pages/seo/AiPromptTemplates";
import PromptLibraryApp from "./pages/seo/PromptLibraryApp";

// Lazy-load articles (their content index is large — keep it out of the main bundle)
const Articles = lazy(() => import("./pages/Articles"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Article = lazy(() => import("./pages/Article"));

// Lazy-load tool components (each gets its own chunk)

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <CookieConsent />
          <Suspense fallback={<div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a1a', color: '#888', fontSize: '14px' }}>Loading…</div>}>
            <Routes>
            <Route path="/" element={<CosmovexLanding />} />
            <Route path="/apps" element={<AppsIndex />} />
            <Route path="/apps/xmlvedit" element={<XMLVEditLanding />} />
            <Route path="/apps/pyvedit" element={<PyVEditLanding />} />
            <Route path="/apps/sqlvedit" element={<SQLVEditLanding />} />
            <Route path="/apps/hostpilot" element={<HostPilotLanding />} />
            <Route path="/apps/aspenote" element={<AspenoteLanding />} />
            <Route path="/apps/agentpager" element={<AgentPagerLanding />} />
            {/* The app was MDPilot until 2026-09-23. Every old link keeps working. */}
            <Route path="/apps/mdpilot" element={<Navigate to="/apps/agentpager" replace />} />
            <Route path="/apps/agentpager/get" element={<AgentPagerGet />} />
            {/* The house pattern elsewhere is /download, so both spellings land somewhere. */}
            <Route path="/apps/agentpager/download" element={<AgentPagerGet />} />
            <Route path="/apps/:appId" element={<AppPromoPage />} />
            <Route path="/get/:appId" element={<SmartDownload />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:slug" element={<Article />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <BlogAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/studio"
              element={
                <ProtectedRoute>
                  <ContentStudio />
                </ProtectedRoute>
              }
            />
            <Route
              path="/apps/pdfaitoolkit/download"
              element={<AppDownloadPage />}
            />
            <Route
              path="/apps/iftracker/privacy-policy"
              element={<IFTrackerPrivacy />}
            />
            <Route
              path="/apps/iftracker/account-deletion"
              element={<AccountDeletion />}
            />
            <Route
              path="/apps/pdfaitoolkit/privacy-policy"
              element={<PDFToolkitPrivacy />}
            />
            <Route
              path="/apps/pdfaitoolkit/account-deletion"
              element={<PDFToolkitAIAccountDeletion />}
            />
            <Route
              path="/apps/easykhata/privacy-policy"
              element={<EasyKhataPrivacyPolicy />}
            />
            <Route
              path="/apps/easykhata/account-deletion"
              element={<EasyKhataAccountDeletion />}
            />
            <Route
              path="/apps/webeva/privacy-policy"
              element={<WebEvaPrivacy />}
            />
            <Route
              path="/apps/webeva/account-deletion"
              element={<WebEvaAccountDeletion />}
            />
            <Route
              path="/apps/webeva/support"
              element={<WebEvaSupport />}
            />
            <Route
              path="/apps/htmlvedit/privacy-policy"
              element={<HTMLVEditPrivacy />}
            />
            <Route
              path="/apps/htmlvedit/support"
              element={<HTMLVEditSupport />}
            />
            <Route
              path="/apps/jsonvedit/privacy-policy"
              element={<JSONVEditPrivacy />}
            />
            <Route
              path="/apps/jsonvedit/support"
              element={<JSONVEditSupport />}
            />
            <Route
              path="/apps/diagrammaker/privacy-policy"
              element={<DiagramMakerPrivacy />}
            />
            <Route
              path="/apps/diagrammaker/support"
              element={<DiagramMakerSupport />}
            />
            <Route
              path="/apps/promptcrate/privacy-policy"
              element={<PromptCratePrivacy />}
            />
            <Route
              path="/apps/promptcrate/support"
              element={<PromptCrateSupport />}
            />
            <Route
              path="/apps/qrpilot/privacy-policy"
              element={<QRPilotPrivacy />}
            />
            <Route
              path="/apps/qrpilot/support"
              element={<QRPilotSupport />}
            />
            <Route
              path="/apps/reelpilot/privacy-policy"
              element={<ReelPilotPrivacy />}
            />
            <Route
              path="/apps/reelpilot/support"
              element={<ReelPilotSupport />}
            />
            <Route
              path="/apps/xmlvedit/privacy-policy"
              element={<XMLVEditPrivacy />}
            />
            <Route
              path="/apps/xmlvedit/support"
              element={<XMLVEditSupport />}
            />
            <Route
              path="/apps/sqlvedit/privacy-policy"
              element={<SQLVEditPrivacy />}
            />
            <Route
              path="/apps/sqlvedit/support"
              element={<SQLVEditSupport />}
            />
            <Route
              path="/apps/nettoolkit/privacy-policy"
              element={<NetToolkitPrivacy />}
            />
            <Route
              path="/apps/nettoolkit/support"
              element={<NetToolkitSupport />}
            />
            <Route
              path="/apps/mdvedit/privacy-policy"
              element={<MDVEditPrivacy />}
            />
            <Route
              path="/apps/mdvedit/support"
              element={<MDVEditSupport />}
            />
            <Route
              path="/apps/textvedit/privacy-policy"
              element={<TextVEditPrivacy />}
            />
            <Route
              path="/apps/textvedit/support"
              element={<TextVEditSupport />}
            />
            <Route
              path="/apps/csvvedit/privacy-policy"
              element={<CSVVEditPrivacy />}
            />
            <Route
              path="/apps/csvvedit/support"
              element={<CSVVEditSupport />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/apps/devbuddy/privacy-policy"
              element={<DevBuddyPrivacy />}
            />
            <Route
              path="/apps/devbuddy/support"
              element={<DevBuddySupport />}
            />
            <Route
              path="/apps/shellpilot/privacy-policy"
              element={<ShellPilotPrivacy />}
            />
            <Route
              path="/apps/shellpilot/account-deletion"
              element={<ShellPilotAccountDeletion />}
            />
            <Route
              path="/apps/shellpilot/support"
              element={<ShellPilotSupport />}
            />
            <Route
              path="/restpilot/privacy-policy"
              element={<RESTPilotPrivacy />}
            />
            <Route
              path="/restpilot/support"
              element={<RESTPilotSupport />}
            />
            <Route
              path="/apps/fitterai/privacy-policy"
              element={<FitterAIPrivacy />}
            />
            <Route
              path="/apps/fitterai/terms"
              element={<FitterAITerms />}
            />
            <Route
              path="/apps/fitterai/support"
              element={<FitterAISupport />}
            />
            <Route
              path="/apps/fitterai/account-deletion"
              element={<FitterAIAccountDeletion />}
            />
            <Route
              path="/apps/pdfveditai/privacy-policy"
              element={<PDFVEditAIPrivacy />}
            />
            <Route
              path="/apps/pdfveditai/account-deletion"
              element={<PDFVEditAIAccountDeletion />}
            />
            <Route
              path="/apps/pdfveditai/support"
              element={<PDFVEditAISupport />}
            />
            <Route
              path="/apps/pyvedit/privacy-policy"
              element={<PyVEditPrivacy />}
            />
            <Route
              path="/apps/pyvedit/support"
              element={<PyVEditSupport />}
            />
            <Route
              path="/apps/javavedit/privacy-policy"
              element={<JavaVEditPrivacy />}
            />
            <Route
              path="/apps/javavedit/support"
              element={<JavaVEditSupport />}
            />
            <Route
              path="/apps/jsvedit/privacy-policy"
              element={<JSVEditPrivacy />}
            />
            <Route
              path="/apps/jsvedit/support"
              element={<JSVEditSupport />}
            />
            <Route
              path="/apps/svgvedit/privacy-policy"
              element={<SVGVEditPrivacy />}
            />
            <Route
              path="/apps/svgvedit/support"
              element={<SVGVEditSupport />}
            />
            <Route
              path="/apps/markpilot/privacy-policy"
              element={<MarkPilotPrivacy />}
            />
            <Route
              path="/apps/markpilot/support"
              element={<MarkPilotSupport />}
            />
            <Route
              path="/apps/hostpilot/privacy-policy"
              element={<HostPilotPrivacy />}
            />
            <Route
              path="/apps/hostpilot/support"
              element={<HostPilotSupport />}
            />
            <Route
              path="/apps/imgpilot/privacy-policy"
              element={<ImgPilotPrivacy />}
            />
            <Route
              path="/apps/imgpilot/support"
              element={<ImgPilotSupport />}
            />
            <Route
              path="/apps/heicvedit/privacy-policy"
              element={<HeicveditPrivacy />}
            />
            <Route
              path="/apps/heicvedit/support"
              element={<HeicveditSupport />}
            />
            <Route
              path="/apps/yamlvedit/privacy-policy"
              element={<YamlveditPrivacy />}
            />
            <Route
              path="/apps/yamlvedit/support"
              element={<YamlveditSupport />}
            />
            <Route
              path="/apps/zipvedit/privacy-policy"
              element={<ZipVEditPrivacy />}
            />
            <Route
              path="/apps/zipvedit/support"
              element={<ZipVEditSupport />}
            />
            <Route
              path="/apps/layerpeek/privacy-policy"
              element={<LayerPeekPrivacy />}
            />
            <Route
              path="/apps/layerpeek/support"
              element={<LayerPeekSupport />}
            />
            <Route
              path="/apps/partydare/privacy-policy"
              element={<PartyDarePrivacy />}
            />
            <Route
              path="/apps/partydare/support"
              element={<PartyDareSupport />}
            />
            <Route
              path="/apps/agentpager/privacy-policy"
              element={<AgentPagerPrivacy />}
            />
            <Route
              path="/apps/agentpager/support"
              element={<AgentPagerSupport />}
            />
            <Route
              path="/apps/mdpilot/privacy-policy"
              element={<AgentPagerPrivacy />}
            />
            <Route
              path="/apps/mdpilot/support"
              element={<AgentPagerSupport />}
            />
            <Route
              path="/apps/codetycoon/privacy-policy"
              element={<CodeTycoonPrivacy />}
            />
            <Route
              path="/apps/codetycoon/support"
              element={<CodeTycoonSupport />}
            />
            <Route
              path="/apps/cvedit/privacy-policy"
              element={<CVEditPrivacy />}
            />
            <Route
              path="/apps/cvedit/support"
              element={<CVEditSupport />}
            />
            <Route
              path="/apps/phpvedit/privacy-policy"
              element={<PHPVEditPrivacy />}
            />
            <Route
              path="/apps/phpvedit/support"
              element={<PHPVEditSupport />}
            />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/unsubscribe" element={<UnsubscribePage />} />
            {/* ── SEO LANDING PAGES ── */}
            <Route path="/java-ide-android" element={<JavaIdeAndroid />} />
            <Route path="/run-java-on-phone" element={<RunJavaOnPhone />} />
            <Route path="/javascript-editor-android" element={<JavascriptEditorAndroid />} />
            <Route path="/run-javascript-on-phone" element={<RunJavascriptOnPhone />} />
            <Route path="/sqlite-viewer-android" element={<SqliteViewerAndroid />} />
            <Route path="/sql-runner-android" element={<SqlRunnerAndroid />} />
            <Route path="/python-on-android" element={<PythonOnAndroid />} />
            <Route path="/offline-python-android" element={<OfflinePythonAndroid />} />
            <Route path="/python-compiler-android" element={<PythonCompilerAndroid />} />
            <Route path="/learn-python-on-phone" element={<LearnPythonOnPhone />} />
            <Route path="/ssh-client-android" element={<SshClientAndroid />} />
            <Route path="/sftp-client-android" element={<SftpClientAndroid />} />
            <Route path="/putty-for-android" element={<PuttyForAndroid />} />
            <Route path="/terminal-emulator-android" element={<TerminalEmulatorAndroid />} />
            <Route path="/manage-server-from-phone" element={<ManageServerFromPhone />} />
            <Route path="/termux-alternative-android" element={<TermuxAlternativeAndroid />} />
            <Route path="/juicessh-alternative-android" element={<JuiceSshAlternativeAndroid />} />
            <Route path="/website-builder-android" element={<WebsiteBuilderAndroid />} />
            <Route path="/html-editor-mobile" element={<HtmlEditorMobile />} />
            <Route path="/xml-viewer-android" element={<XmlViewerAndroid />} />
            <Route path="/json-viewer-android" element={<JsonViewerAndroid />} />
            <Route path="/svg-editor-android" element={<SvgEditorAndroid />} />
            <Route path="/csv-viewer-android" element={<CsvViewerAndroid />} />
            <Route path="/pdf-editor-android" element={<PdfEditorAndroid />} />
            <Route path="/unit-converter-android" element={<UnitConverterAndroid />} />
            <Route path="/yaml-viewer-android" element={<YamlViewerAndroid />} />
            <Route path="/markdown-editor-android" element={<MarkdownEditorAndroid />} />
            <Route path="/text-editor-android" element={<TextEditorAndroid />} />
            <Route path="/network-tools-android" element={<NetworkToolsAndroid />} />
            <Route path="/fitness-ai-android" element={<FitnessAiAndroid />} />
            <Route path="/rest-api-tester-android" element={<RestApiTesterAndroid />} />
            <Route path="/html-viewer-android" element={<HtmlViewerAndroid />} />
            <Route path="/json-formatter-android" element={<JsonFormatterAndroid />} />
            <Route path="/sql-editor-android" element={<SqlEditorAndroid />} />
            <Route path="/yaml-editor-android" element={<YamlEditorAndroid />} />
            <Route path="/developer-tools-android" element={<DeveloperToolsAndroid />} />
            <Route path="/java-compiler-android" element={<JavaCompilerAndroid />} />
            <Route path="/diagram-maker-android" element={<DiagramMakerAndroid />} />
            <Route path="/qr-scanner-android" element={<QrScannerAndroid />} />
            <Route path="/qr-code-generator-android" element={<QrCodeGeneratorAndroid />} />
            <Route path="/barcode-scanner-android" element={<BarcodeScannerAndroid />} />
            <Route path="/zip-extractor-android" element={<ZipExtractorAndroid />} />
            <Route path="/ai-prompt-manager-android" element={<AiPromptManagerAndroid />} />
            <Route path="/ai-markdown-notes-android" element={<AiMarkdownNotesAndroid />} />
            <Route path="/save-chatgpt-prompts" element={<SaveChatgptPrompts />} />
            <Route path="/ai-prompt-templates" element={<AiPromptTemplates />} />
            <Route path="/prompt-library-app" element={<PromptLibraryApp />} />
            <Route path="*" element={<NotFound />} />
            {/* ── TOOLS HUB ── */}
            {/* ── TOOL PAGES ── */}
          </Routes>
          </Suspense>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
